if (!customElements.get('beau-quick-add')) {
  customElements.define(
    'beau-quick-add',
    class BeauQuickAdd extends HTMLElement {
      connectedCallback() {
        this.status = this.querySelector('.beau-quick-add__status');
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
        });
      }

      onClick(event) {
        const guide = event.target.closest('[data-open-size-guide]');
        if (guide) {
          event.preventDefault();
          event.stopPropagation();
          openBeauSizeGuide(guide.dataset.sizeGuide);
          return;
        }

        const toggle = event.target.closest('[data-quick-add-toggle]');
        if (toggle) {
          event.preventDefault();
          event.stopPropagation();
          this.togglePanel();
          return;
        }

        const button = event.target.closest('[data-variant-id]');
        if (!button || button.disabled || this.busy) return;
        event.preventDefault();
        event.stopPropagation();
        this.addVariant(button);
      }

      cardWrapper() {
        return this.closest('.card-wrapper');
      }

      syncSaleBadge() {
        const card = this.cardWrapper();
        if (!card) return;
        if (this.classList.contains('is-open')) {
          card.style.setProperty('--quick-add-h', `${this.offsetHeight}px`);
        } else {
          card.style.removeProperty('--quick-add-h');
        }
      }

      closePanel() {
        this.classList.remove('is-open');
        this.syncSaleBadge();
      }

      togglePanel() {
        const opening = !this.classList.contains('is-open');
        document.querySelectorAll('beau-quick-add.is-open').forEach((el) => {
          if (el !== this) el.closePanel();
        });
        this.classList.toggle('is-open', opening);
        this.syncSaleBadge();
      }

      addVariant(button) {
        this.busy = true;
        button.classList.add('is-loading');

        const formData = new FormData();
        formData.append('id', button.dataset.variantId);
        formData.append('quantity', '1');

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id).join(',')
          );
          formData.append('sections_url', window.location.pathname);
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showStatus(response.description || 'Could not add to cart');
              return;
            }

            this.showStatus('Added');
            if (this.cart && typeof this.cart.renderContents === 'function') {
              this.cart.classList.remove('is-empty');
              this.cart.querySelector('.drawer__inner')?.classList.remove('is-empty');
              this.cart.querySelector('cart-drawer-items')?.classList.remove('is-empty');
              this.cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch(() => {
            this.showStatus('Could not add to cart');
          })
          .finally(() => {
            this.busy = false;
            button.classList.remove('is-loading');
          });
      }

      showStatus(message) {
        if (!this.status) return;
        this.status.hidden = false;
        this.status.textContent = message;
        window.clearTimeout(this.statusTimer);
        this.statusTimer = window.setTimeout(() => {
          this.status.hidden = true;
        }, 1800);
      }
    }
  );
}

const BEAU_SIZE_CHARTS = {
  women: "Women's size guide",
  men: "Men's size guide",
  international: 'International size guide',
};

function setBeauSizeChart(root, chartId) {
  if (!root) return;
  if (!BEAU_SIZE_CHARTS[chartId]) chartId = 'women';

  root.dataset.activeChart = chartId;

  const title = root.querySelector('[data-chart-title]');
  if (title) title.textContent = BEAU_SIZE_CHARTS[chartId];

  root.querySelectorAll('[data-chart]').forEach((panel) => {
    const isActive = panel.dataset.chart === chartId;
    panel.classList.toggle('is-active', isActive);
    panel.toggleAttribute('aria-hidden', !isActive);
  });
  root.querySelectorAll('[data-show-chart]').forEach((button) => {
    button.hidden = button.dataset.showChart === chartId;
  });
}

function openBeauSizeGuide(chartId) {
  const dialog = document.getElementById('BeauSizeGuide');
  if (!dialog) return;
  setBeauSizeChart(dialog.querySelector('.beau-size-charts'), chartId || 'women');
  dialog.showModal();
}

if (window.location.pathname.indexOf('/pages/size-guide') !== -1) {
  document.addEventListener('DOMContentLoaded', () => openBeauSizeGuide('women'));
}

document.addEventListener('click', (event) => {
  const switchBtn = event.target.closest('[data-show-chart]');
  if (switchBtn) {
    event.preventDefault();
    setBeauSizeChart(switchBtn.closest('.beau-size-charts'), switchBtn.dataset.showChart);
    return;
  }

  const opener = event.target.closest('[data-open-size-guide]');
  if (opener) {
    event.preventDefault();
    openBeauSizeGuide(opener.dataset.sizeGuide || 'women');
    return;
  }

  const sizeGuideLink = event.target.closest('a');
  if (sizeGuideLink) {
    const href = (sizeGuideLink.getAttribute('href') || '').toLowerCase();
    const label = (sizeGuideLink.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (
      href.includes('/pages/size-guide') ||
      href.includes('abc12') ||
      label === 'size guide'
    ) {
      event.preventDefault();
      openBeauSizeGuide('women');
      return;
    }
  }

  const dialog = document.getElementById('BeauSizeGuide');
  if (dialog && (event.target.closest('[data-close-size-guide]') || event.target === dialog)) {
    dialog.close();
  }

  if (!event.target.closest('beau-quick-add')) {
    document.querySelectorAll('beau-quick-add.is-open').forEach((el) => el.closePanel());
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.getElementById('BeauSizeGuide')?.close();
  document.querySelectorAll('beau-quick-add.is-open').forEach((el) => el.closePanel());
});
